import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    FormSelectChoice, FormFieldComponentProps, VerificationServiceProps, Country, Locale,
} from '../../../lib/types/types';
import { TypeaheadComponent } from '../../FormInputs/Typeahead/TypeaheadComponent';
import { getSafe } from '../../../lib/utils/objects';
import { getOptions } from '../../../options/options';
import { getLocaleSafely } from '../../../lib/intl/intl';
import { getOrgSearchCountryTags } from '../../../lib/ProgramTheme/programThemeGetters';

export const TeacherSchool = ({
    value,
    isErrored,
    onChange,
    verificationService,
    intl,
    placeholder = '',
}: FormFieldComponentProps & VerificationServiceProps) => {
    const { programId, viewModel, verificationResponse } = verificationService;
    const id = 'sid-teacher-school';
    const locale: Locale = getLocaleSafely(viewModel, verificationResponse);
    const urlAddSchoolForm = (getOptions().urlAddSchoolForm || '').trim();
    const country = getSafe<Country>(() => verificationService.viewModel.countryChoice.value);
    const searchTags = getOrgSearchCountryTags(verificationService.programTheme, country);

    return (
        <div className="sid-field sid-teacher-school-id">
            <div className="sid-l-space-top-md" />
            <label htmlFor={id}>
                <div id={`${id}-label`} className="sid-field__label sid-field__label--required sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="schoolName"
                        defaultMessage="School name"
                    />
                </div>
            </label>
            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={country}
                onChange={(choice: FormSelectChoice) => onChange(choice)}
                minimumSearchValueLength={getOptions().minimumOrganizationSearchLength}
                placeholder={placeholder || intl.formatMessage({ id: 'schoolNamePlaceholder', defaultMessage: 'University / College name*' })}
                programId={programId}
                value={value}
                inputHtmlId={id}
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
                orgSearchTags={searchTags}
                locale={locale}
                urlAddSchoolForm={urlAddSchoolForm}
                isRequired
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidOrganization"
                            defaultMessage="You must select an organization from the list"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const TeacherSchoolComponent = injectIntl(TeacherSchool);
